"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Badge } from "@/components/ui/badge";
import { Phone } from "lucide-react";
import { useEffect, useState } from "react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-3">
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
        <div className="h-9 w-20 bg-muted/30 animate-pulse rounded-md" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-wrap justify-center">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="group relative px-5 py-2 text-sm font-semibold text-foreground transition-colors hover:text-primary">
                {item.label}
                <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-accent transition-all duration-300 ease-out-back group-hover:w-full" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Header() {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScroll, setLastScroll] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      if (currentScroll > window.innerHeight && currentScroll > lastScroll) {
        setIsVisible(false);
      } else if (currentScroll < lastScroll || currentScroll <= 0) {
        setIsVisible(true);
      }
      setLastScroll(currentScroll);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScroll]);
  return <header className={`fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border shadow-soft transition-all duration-300 ${isVisible ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"}`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-3">
          {}
          <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
            <img src="https://talented-bat.10web.cloud/wp-content/uploads/2025/11/Screenshot-2025-08-26-101538-1.png" alt="D&J Entertainment" className="h-7" />
          </Link>

          {}
          <nav className="hidden md:block">
            <MenuProvider menu_id="17">
              <HeaderMenuConsumer />
            </MenuProvider>
          </nav>

          {}
          <Badge variant="outline" className="hidden md:flex items-center gap-2 px-4 py-2 border-primary/40 bg-primary/5 text-primary hover:bg-primary/10 animate-pulse" asChild>
            <Link to="tel:(123) 456-7890" className="flex items-center gap-2">
              <Phone className="size-4" />
              <span className="font-semibold">(636) 235-1115</span>
            </Link>
          </Badge>

          {}
          <button className="md:hidden p-2 rounded-md hover:bg-accent/10 transition-colors" aria-label="Toggle menu">
            <svg className="size-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </header>;
}